// extracted by mini-css-extract-plugin
module.exports = {"modal_animation_duration":"200ms","text":"onfido-sdk-ui-Welcome-text"};